import { CatalogService } from './CatalogService';

export class CompanyService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}
// import axios from "axios";
// import { CompanyDto } from "../../dtos/catalogs/company/CompanyDto";

// export class CompanyService {
//     async getAll(): Promise<CompanyDto[]> {
//         const response = await axios.get("Company");
//         return response.data;
//     }
// }